var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGmailInvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7240_24362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3145 41.9627H16.0934V27.9283L12.3093 21.3206L7.83789 21.7367V39.4861C7.83789 40.8544 8.94621 41.9627 10.3145 41.9627Z",
    fill: "#0085F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9072 41.9627H41.6861C43.0545 41.9627 44.1628 40.8544 44.1628 39.4861V21.7367L39.6978 21.3206L35.9073 27.9283V41.9627H35.9072Z",
    fill: "#00A94B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9063 17.1962L32.5117 23.6738L35.9063 27.9284L44.1618 21.7367V18.4346C44.1618 15.3738 40.6677 13.6257 38.2178 15.4626L35.9063 17.1962Z",
    fill: "#FFBC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.093 27.9285L12.8584 21.0957L16.093 17.1963L25.9996 24.6262L35.9063 17.1963V27.9285L25.9996 35.3585L16.093 27.9285Z",
    fill: "#FF4131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83789 18.4346V21.7367L16.0934 27.9284V17.1962L13.7819 15.4626C11.332 13.6257 7.83789 15.3738 7.83789 18.4346Z",
    fill: "#E51C19"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7240_24362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4952 18.0763C29.2016 19.0624 27.6265 19.6086 26.0001 19.6352C20.7028 19.6352 17.6758 13.5812 17.6758 13.5812C18.6171 11.8269 19.9227 10.2943 21.505 9.08604M24.4109 7.70874C24.9318 7.58681 25.4651 7.52586 26.0001 7.52712C31.2974 7.52712 34.3244 13.5812 34.3244 13.5812C33.8651 14.4406 33.3172 15.2496 32.6898 15.9952M27.6044 15.1855C27.3966 15.4085 27.1459 15.5875 26.8675 15.7115C26.589 15.8356 26.2884 15.9023 25.9835 15.9077C25.6787 15.9131 25.3759 15.857 25.0932 15.7428C24.8105 15.6287 24.5537 15.4587 24.3382 15.2431C24.1226 15.0275 23.9526 14.7708 23.8384 14.4881C23.7243 14.2054 23.6682 13.9026 23.6736 13.5978C23.6789 13.2929 23.7457 12.9923 23.8697 12.7138C23.9938 12.4353 24.1727 12.1847 24.3958 11.9768",
    fill: "#7BCDE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4952 18.0763C29.2016 19.0624 27.6265 19.6086 26.0001 19.6352C20.7028 19.6352 17.6758 13.5812 17.6758 13.5812C18.6171 11.8269 19.9227 10.2943 21.505 9.08604M24.4109 7.70874C24.9318 7.58681 25.4651 7.52586 26.0001 7.52712C31.2974 7.52712 34.3244 13.5812 34.3244 13.5812C33.8651 14.4406 33.3172 15.2496 32.6898 15.9952M27.6044 15.1855C27.3966 15.4085 27.1459 15.5875 26.8675 15.7115C26.589 15.8356 26.2884 15.9023 25.9835 15.9077C25.6787 15.9131 25.3759 15.857 25.0932 15.7428C24.8105 15.6287 24.5537 15.4587 24.3382 15.2431C24.1226 15.0275 23.9526 14.7708 23.8384 14.4881C23.7243 14.2054 23.6682 13.9026 23.6736 13.5978C23.6789 13.2929 23.7457 12.9923 23.8697 12.7138C23.9938 12.4353 24.1727 12.1847 24.3958 11.9768",
    stroke: "#050505",
    strokeWidth: 1.51351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6758 5.25684L34.3244 21.9055",
    stroke: "#050505",
    strokeWidth: 1.51351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7240_24362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.3243,
    height: 36.3243,
    fill: "white",
    transform: "translate(7.83789 10.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7240_24362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1622,
    height: 18.1622,
    fill: "white",
    transform: "translate(16.9189 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGmailInvisible);
export default __webpack_public_path__ + "static/media/icon_gmail_invisible.9ae0b9b25d30a4eec613072a23595e49.svg";
export { ForwardRef as ReactComponent };